import React from "react";
import { Helmet } from 'react-helmet-async';
import MySwiperComponent from "../Componentes/carruselProductos";
import FiltroHome from "../Componentes/filtroHome";
import "./css/Home.css";
import { GetDatos } from "../json/Datos";
import { useNavigate } from "react-router-dom";
import VuelveArriba from "../Componentes/vuelveArriba";
import { Spinner } from 'react-bootstrap';


const Home = () => {
  const { loading, datos } = GetDatos();  // Extrae 'datos' directamente
  const navigate = useNavigate();

  document.title = "Susana Espinoza - PROPIEDADES INMOBILIARIAS";

  const handleClick = () => {
    navigate("/tasaciones");
  };
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }
  return (
    <div>
      <Helmet>
        <title>Susana Espinoza - Home</title>
        <meta name="description" content="Busca tu propiedad ideal. ¡Haz realidad tu sueño! - Inmobiliaria - Bella Vista - San miguel - Muñiz - Susana Espinoza  " />
        <meta property="og:title" content="Susana Espinoza - Propiedades" />
        <meta property="og:description" content="Busca tu propiedad ideal. ¡Haz realidad tu sueño!" />
        <meta property="og:image" content="https://susanaespinoza.com.ar/favicon.ico" />
      </Helmet>
      <VuelveArriba>
        <section className="inicio">
          <img className="inicio-img" src="./assets/img/inicio - copia.jpg" alt="Imagen de inicio" />
          <div className="home-text-container">
            <h1 className="inicio-titulo"><strong>Tu hogar, nuestro compromiso</strong></h1>
            <h3 className="inicio-parrafo"><strong>Encuentra la casa de tus sueños con nosotros</strong></h3>
            <FiltroHome />
          </div>
        </section>

        <div className="destacado">
          <MySwiperComponent catalogoCompleto={datos} />
        </div>

        <div className="tasamos-wrapper">
          <div className="tasamos-circulo">
            <h2><strong>Tasamos Tu Propiedad</strong></h2>
            <button className="btn btn-dark" onClick={handleClick}>Tasar Mi Propiedad</button>
          </div>
        </div>
      </VuelveArriba>
    </div>
  );
};

export default Home;
